/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PartnerAdCampaignsByContextFragment = {
  __typename?: 'PartnerAdCampaignsQuery';
} & {
  listByContext: Types.Maybe<
    Array<
      { __typename?: 'PartnerAdCampaign' } & Pick<
        Types.PartnerAdCampaign,
        | 'id'
        | 'name'
        | 'title'
        | 'linkUrl'
        | 'subtitle'
        | 'logoUrl'
        | 'productIds'
        | 'pageType'
        | 'trackingId'
        | 'sellerAccountId'
      > & {
          image: { __typename?: 'PartnerAdCampaignImage' } & Pick<
            Types.PartnerAdCampaignImage,
            'desktopUrl' | 'mobileUrl' | 'altText'
          >;
          label: Types.Maybe<
            { __typename?: 'PartnerAdCampaignLabel' } & Pick<
              Types.PartnerAdCampaignLabel,
              'line1' | 'line2' | 'format'
            >
          >;
        }
    >
  >;
};

export type PartnerAdCampaignsPromoBlockQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  channel: Types.Channel;
  space: Types.PartnerAdSpace;
  sessionId: Types.Scalars['ID']['input'];
}>;

export type PartnerAdCampaignsPromoBlockQuery = { __typename?: 'Query' } & {
  partnerAdCampaigns: Types.Maybe<
    { __typename?: 'PartnerAdCampaignsQuery' } & {
      listByContext: Types.Maybe<
        Array<
          { __typename?: 'PartnerAdCampaign' } & Pick<
            Types.PartnerAdCampaign,
            | 'id'
            | 'name'
            | 'title'
            | 'linkUrl'
            | 'subtitle'
            | 'logoUrl'
            | 'productIds'
            | 'pageType'
            | 'trackingId'
            | 'sellerAccountId'
          > & {
              image: { __typename?: 'PartnerAdCampaignImage' } & Pick<
                Types.PartnerAdCampaignImage,
                'desktopUrl' | 'mobileUrl' | 'altText'
              >;
              label: Types.Maybe<
                { __typename?: 'PartnerAdCampaignLabel' } & Pick<
                  Types.PartnerAdCampaignLabel,
                  'line1' | 'line2' | 'format'
                >
              >;
            }
        >
      >;
    }
  >;
};

export type PartnerAdCampaignsBrandBlockQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  channel: Types.Channel;
  space: Types.PartnerAdSpace;
  sessionId: Types.Scalars['ID']['input'];
}>;

export type PartnerAdCampaignsBrandBlockQuery = { __typename?: 'Query' } & {
  partnerAdCampaigns: Types.Maybe<
    { __typename?: 'PartnerAdCampaignsQuery' } & {
      listByContext: Types.Maybe<
        Array<
          { __typename?: 'PartnerAdCampaign' } & Pick<
            Types.PartnerAdCampaign,
            | 'id'
            | 'name'
            | 'title'
            | 'linkUrl'
            | 'subtitle'
            | 'logoUrl'
            | 'productIds'
            | 'pageType'
            | 'trackingId'
            | 'sellerAccountId'
          > & {
              image: { __typename?: 'PartnerAdCampaignImage' } & Pick<
                Types.PartnerAdCampaignImage,
                'desktopUrl' | 'mobileUrl' | 'altText'
              >;
              label: Types.Maybe<
                { __typename?: 'PartnerAdCampaignLabel' } & Pick<
                  Types.PartnerAdCampaignLabel,
                  'line1' | 'line2' | 'format'
                >
              >;
            }
        >
      >;
    }
  >;
};

export type PartnerAdCampaignsRectangularBlockQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  channel: Types.Channel;
  space: Types.PartnerAdSpace;
  sessionId: Types.Scalars['ID']['input'];
}>;

export type PartnerAdCampaignsRectangularBlockQuery = {
  __typename?: 'Query';
} & {
  partnerAdCampaigns: Types.Maybe<
    { __typename?: 'PartnerAdCampaignsQuery' } & {
      listByContext: Types.Maybe<
        Array<
          { __typename?: 'PartnerAdCampaign' } & Pick<
            Types.PartnerAdCampaign,
            | 'id'
            | 'name'
            | 'title'
            | 'linkUrl'
            | 'subtitle'
            | 'logoUrl'
            | 'productIds'
            | 'pageType'
            | 'trackingId'
            | 'sellerAccountId'
          > & {
              image: { __typename?: 'PartnerAdCampaignImage' } & Pick<
                Types.PartnerAdCampaignImage,
                'desktopUrl' | 'mobileUrl' | 'altText'
              >;
              label: Types.Maybe<
                { __typename?: 'PartnerAdCampaignLabel' } & Pick<
                  Types.PartnerAdCampaignLabel,
                  'line1' | 'line2' | 'format'
                >
              >;
            }
        >
      >;
    }
  >;
};

export const PartnerAdCampaignsByContextFragmentDoc = /*#__PURE__*/ `
    fragment partnerAdCampaignsByContext on PartnerAdCampaignsQuery {
  listByContext(
    context: {platform: $platform, market: $market, channel: $channel, space: $space, sessionId: $sessionId}
  ) {
    id
    name
    title
    linkUrl
    image {
      desktopUrl
      mobileUrl
      altText
    }
    label {
      line1
      line2
      format
    }
    subtitle
    logoUrl
    productIds
    pageType
    trackingId
    sellerAccountId
  }
}
    `;
export const PartnerAdCampaignsPromoBlockDocument = /*#__PURE__*/ `
    query PartnerAdCampaignsPromoBlock($platform: Platform!, $market: Market!, $channel: Channel!, $space: PartnerAdSpace!, $sessionId: ID!) {
  partnerAdCampaigns {
    ...partnerAdCampaignsByContext
  }
}
    ${PartnerAdCampaignsByContextFragmentDoc}`;

export function usePartnerAdCampaignsPromoBlockQuery(
  options: Omit<
    Urql.UseQueryArgs<PartnerAdCampaignsPromoBlockQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    PartnerAdCampaignsPromoBlockQuery,
    PartnerAdCampaignsPromoBlockQueryVariables
  >({ query: PartnerAdCampaignsPromoBlockDocument, ...options });
}
export const PartnerAdCampaignsBrandBlockDocument = /*#__PURE__*/ `
    query PartnerAdCampaignsBrandBlock($platform: Platform!, $market: Market!, $channel: Channel!, $space: PartnerAdSpace!, $sessionId: ID!) {
  partnerAdCampaigns {
    ...partnerAdCampaignsByContext
  }
}
    ${PartnerAdCampaignsByContextFragmentDoc}`;

export function usePartnerAdCampaignsBrandBlockQuery(
  options: Omit<
    Urql.UseQueryArgs<PartnerAdCampaignsBrandBlockQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    PartnerAdCampaignsBrandBlockQuery,
    PartnerAdCampaignsBrandBlockQueryVariables
  >({ query: PartnerAdCampaignsBrandBlockDocument, ...options });
}
export const PartnerAdCampaignsRectangularBlockDocument = /*#__PURE__*/ `
    query PartnerAdCampaignsRectangularBlock($platform: Platform!, $market: Market!, $channel: Channel!, $space: PartnerAdSpace!, $sessionId: ID!) {
  partnerAdCampaigns {
    ...partnerAdCampaignsByContext
  }
}
    ${PartnerAdCampaignsByContextFragmentDoc}`;

export function usePartnerAdCampaignsRectangularBlockQuery(
  options: Omit<
    Urql.UseQueryArgs<PartnerAdCampaignsRectangularBlockQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    PartnerAdCampaignsRectangularBlockQuery,
    PartnerAdCampaignsRectangularBlockQueryVariables
  >({ query: PartnerAdCampaignsRectangularBlockDocument, ...options });
}
